module.exports = __webpack_public_path__ + "img/tuanduidefen.b258c841.png";